import creativesManagerAgent from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/creativesManagerAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import creativesManagerSkill from 'common/src/modules/shared/copilot/skills/definitions/creativesManagerSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeCreativesAgents(store: CLStore) {
  if (!isFlagEnabled(FeatureFlagKey.EnableCopilotSkills)) {
    copilot.registerAgent(creativesManagerAgent(store));
  }

  registerSkill(creativesManagerSkill(store));
}

export default initializeCreativesAgents;
